export type MerchantStatus = 'ACTIVE' | 'MAINTENANCE' | 'ARCHIVED';
export type MerchantType = 'ONLINE' | 'PHYSICAL' | 'ONLINEANDPHYSICAL';
export type MerchantLimitStatus = 'ON' | 'OFF';
export enum MerchantPreferredOfferType {
  CLO = 'CLO',
  REGULAR = 'REGULAR',
}
